import React from 'react';
import BaseStep from 'high-school-student/account-conversion/components/base-step';
import Calendar from 'shared/img/education-onboarding/calendar.svg';
import styles from '../Resume/styles.module.scss';

const ViewScholarships = () => (
  <BaseStep
    stepHeader={
      <>
        <Calendar className={styles.icon} width={150} />
        Check back for added awards
      </>
    }
    subHeader={
      <>
        Check your account often as new award
        <br />
        opportunities may appear!
      </>
    }
  />
);

export default ViewScholarships;
